module.exports = __webpack_public_path__ + "img/assemblies-of-god-logo.16d9364e.png";